import React, { Fragment } from 'react';
import { Card, CardBody, Col, Media } from 'reactstrap';
import { Link } from 'react-router-dom';
import { H1, P, Image } from '../../../AbstractElements';
import dashImg from '../../../assets/images/images.svg';
import ChangePassword from '../../../Component/Admin/ChangePassword';

const Greeting = () => {
  const user = localStorage.getItem('USER');
  const name = user ? JSON.parse(user).name : '';

  return (
    <Fragment>
      <Col xl="12" md="12" className="dash-xl-100 box-col-12">
        <Card className="profile-greeting">
          <CardBody>
            <Media>
              <Media body>
                <div className="greeting-user">
                  <H1>Hello, {name}</H1>
                  <P>Welcome back, your dashboard Admin Brofesional is ready!</P>
                  {/* <Link to={`${process.env.PUBLIC_URL}/main-program`} className="btn btn-outline-white_color" >
                    Ganti Password<i className="icon-arrow-right"></i></Link> */}
                  <ChangePassword />
                </div>
              </Media>
            </Media>
            <div className="cartoon-img">
              <Image attrImage={{ className: 'img-fluid', src: `${dashImg}`, alt: '' }} />
            </div>
          </CardBody>
        </Card>
      </Col>
    </Fragment >
  );
};
export default Greeting;